import "./IvStoreProductsStep.scss";
import {IComponentOptions, IOnDestroy, IOnInit, IScope} from "angular";
import {IvStoreViewStore} from "../../services/IvStoreViewStore";
import {ReplaySubject} from "rxjs";
import {ProductPrices} from "../../models/StoreItemPrices";
import {StoreProductState, StoreProductStates} from "../../../common/models/StoreProductState";
import {IvProductMappings, IvStoreProduct} from "../../models/IvStoreProduct";

export const ProductsStep = "ivStoreProductsStep";

export function productsStep(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/products/IvStoreProductsStep.html`,
        bindings: {
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: IvStoreProductsStepController
    };
}

export class IvStoreProductsStepController implements IOnInit, IOnDestroy {

    public viewStore: IvStoreViewStore;
    public proState: StoreProductState;
    public backtestingState: StoreProductState;
    public alertingState: StoreProductState;
    public bundleState: StoreProductState;

    public prices = ProductPrices;
    public products = IvProductMappings;

    public hasChangedProducts = false;

    private destroyed$ = new ReplaySubject<void>();

    /** @ngInject */
    public constructor(private $scope: IScope) {
    }

    public $onInit(): void {
        this.viewStore
            .productStates
            .takeUntil(this.destroyed$)
            .subscribe((states) => this.statesChanged(states));
    }

    private statesChanged(states: StoreProductStates<IvStoreProduct>) {
        this.$scope.$applyAsync(() => {
            this.proState = states.PRO;
            this.backtestingState = states.BACKTESTING;
            this.alertingState = states.TRADING_SYSTEMS;
            this.bundleState = states.BUNDLE;
            this.hasChangedProducts = this.productStateChanged(this.proState) ||
                this.productStateChanged(this.backtestingState) ||
                this.productStateChanged(this.alertingState) ||
                this.productStateChanged(this.bundleState);
        });
    }

    private productStateChanged(state: StoreProductState) {
        return state.selected && !state.locked;
    }

    public toggleProState() {
        this.viewStore.toggleProState();
    }

    public toggleBacktestingState() {
        this.viewStore.toggleBacktestingState();
    }

    public toggleAlertingState() {
        this.viewStore.toggleAlertingState();
    }

    public toggleBundleState() {
        this.viewStore.toggleBundleState();
    }

    public $onDestroy(): void {
        this.destroyed$.next(void 0);
        this.destroyed$.complete();
    }
}
